import { KollectionType } from '@cyberkongz/api-interfaces';
import { CONTRACTS_BY_NETWORK } from '@cyberkongz/config-blockchain';
import {
  ChainEnhanced,
  getKongzContract,
  getKongzVXContract,
  useChainEnhanced,
  useWatchReadContract,
} from '@cyberkongz/ui-blockchain';
import { useReadContract } from 'wagmi';

function getSubdomainHelperContract(chain?: ChainEnhanced) {
  return CONTRACTS_BY_NETWORK(chain?.name).SubdomainHelper;
}

// temporary hook to get ENS info, delete after Watchers are done
export function useKongSubdomainInfo({
  kollectionType,
  tokenId,
}: {
  kollectionType: KollectionType;
  tokenId: number;
}) {
  const { mainnetChain } = useChainEnhanced();
  const collectionAddress =
    kollectionType === 'vx'
      ? getKongzVXContract(mainnetChain).address
      : getKongzContract(mainnetChain).address;

  const { data, queryKey } = useReadContract({
    ...getSubdomainHelperContract(mainnetChain),
    functionName: 'fetchEnsInfoFor',
    args: [collectionAddress, [BigInt(tokenId)]],
    chainId: mainnetChain?.id,
    query: {
      enabled: !!mainnetChain && !!collectionAddress && !!tokenId,
    },
  });

  useWatchReadContract({ queryKey });

  const name = data?.[0].name;

  return name === '' ? undefined : name;
}
